import { IUser } from '@components/user/IUser';

function getUserKey() {
  try {
    const key = process.env.REACT_APP_USER_KEY;
    if (!key) throw Error(`Must set user key variable in .env`);
    return key;
  } catch (error) {
    console.error(error);
  }
  return '';
}

function setUser(user: IUser) {
  window.localStorage.setItem(getUserKey(), user.name);
}

function getUser() {
  return window.localStorage.getItem(getUserKey());
}

export async function requestSaveUser(user: IUser) {
  try {
    setUser(user);
    return Promise.resolve();
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function requestUser(): Promise<IUser> {
  try {
    const username = getUser();
    if (!username) throw new Error();
    return Promise.resolve({ name: username });
  } catch (error) {
    return Promise.reject();
  }
}

export async function requestLogout() {
  window.localStorage.removeItem(getUserKey());
  return Promise.resolve();
}
